import React from 'react';
import { FC } from 'react';
import styled from 'styled-components';

const _sparkles: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <g clipPath='url(#clip0_39_204)'>
            <path
                d='M8.48438 0.75C8.48438 6.68775 5.2755 12 0.75 12C5.2755 12 8.48438 17.3126 8.48438 23.25C8.48438 17.3126 11.6932 12 16.2188 12C11.6932 12 8.48438 6.68775 8.48438 0.75Z'
                fill='url(#paint0_linear_39_204)'
            />
            <path
                d='M17.6252 12C17.6252 14.9693 16.0213 17.625 13.7578 17.625C16.0213 17.625 17.6252 20.2815 17.6252 23.25C17.6252 20.2815 19.2291 17.625 21.4926 17.625C19.2291 17.625 17.6252 14.9693 17.6252 12Z'
                fill='url(#paint1_linear_39_204)'
            />
            <path
                d='M19.383 0.75C19.383 3.71887 17.7791 6.375 15.5156 6.375C17.7787 6.375 19.383 9.0315 19.383 12C19.383 9.0315 20.9869 6.375 23.2504 6.375C20.9869 6.375 19.383 3.71887 19.383 0.75Z'
                fill='url(#paint2_linear_39_204)'
            />
        </g>
        <defs>
            <linearGradient id='paint0_linear_39_204' x1='8.48438' y1='0.75' x2='8.48438' y2='23.25' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#3B82F6' />
                <stop offset='1' stopColor='#8B5CF6' />
            </linearGradient>
            <linearGradient id='paint1_linear_39_204' x1='17.6252' y1='12' x2='17.6252' y2='23.25' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#3B82F6' />
                <stop offset='1' stopColor='#8B5CF6' />
            </linearGradient>
            <linearGradient id='paint2_linear_39_204' x1='19.383' y1='0.75' x2='19.383' y2='12' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#3B82F6' />
                <stop offset='1' stopColor='#8B5CF6' />
            </linearGradient>
            <clipPath id='clip0_39_204'>
                <rect width='24' height='24' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export const Sparkles = styled(_sparkles)``;
export default Sparkles;
